export default __webpack_public_path__ + "static/media/order-notification-sound.34faa3cb.mp3";